import React, {useEffect} from 'react';
import {generateAIVideosText} from '../generateAIVideosText';
import {
  BACKGROUND_MUSIC_OPTIONS,
  VIDEO_LENGTH_OPTIONS,
} from '../../../../data/models/AI/VideoGenerationOptions';
import ToggleSwitch from '../../../../uiToolkit/Inputs/ToggleSwitch';
import YesNoOption from '../../../../uiToolkit/Inputs/YesNoOption';
import Dropdown from '../../../../uiToolkit/Inputs/Dropdown';
import {MediaFile} from '../../../../data/models/LibraryFile/MediaFile';
import LibraryFilesInput from '../../../../uiToolkit/Inputs/LibraryFilesInput';

interface Props {
  videoDuration?: string;
  setVideoDuration: (value: string) => void;
  enableBackgroundMusic: boolean;
  setEnableBackgroundMusic: (value: boolean) => void;
  backgroundMusicType?: string;
  setBackgroundMusicType: (value: string) => void;
  backgroundAudioFile?: MediaFile;
  setBackgroundAudioFile: (file?: MediaFile) => void;
  onBrowseAudio: () => void;
}

const VideoDuratonStep = React.memo(
  ({
    setVideoDuration,
    videoDuration,
    enableBackgroundMusic,
    setEnableBackgroundMusic,
    backgroundMusicType,
    setBackgroundMusicType,
    backgroundAudioFile,
    setBackgroundAudioFile,
    onBrowseAudio,
  }: Props) => {
    useEffect(() => {
      if (
        enableBackgroundMusic &&
        !backgroundAudioFile &&
        !backgroundMusicType &&
        BACKGROUND_MUSIC_OPTIONS.length > 0
      ) {
        setBackgroundMusicType(BACKGROUND_MUSIC_OPTIONS[0].key);
      }
    }, [
      enableBackgroundMusic,
      backgroundMusicType,
      setBackgroundMusicType,
      backgroundAudioFile,
    ]);

    const onMusicTypeChange = (value: string) => {
      setBackgroundMusicType(value);
      setBackgroundAudioFile(undefined);
    };

    const onRemoveAudioFile = () => {
      setBackgroundAudioFile(undefined);
      if (!backgroundMusicType && BACKGROUND_MUSIC_OPTIONS.length > 0) {
        setBackgroundMusicType(BACKGROUND_MUSIC_OPTIONS[0].key);
      }
    };

    return (
      <div className="StepContainer">
        <h5 className="StepTitle">{generateAIVideosText.videoSettingsTitle}</h5>
        <h5 className="SectionTitle mt-4">
          {generateAIVideosText.videoDurationLabel}
        </h5>
        <div className="DurationCheckboxGroup">
          <ToggleSwitch
            options={VIDEO_LENGTH_OPTIONS}
            onChange={setVideoDuration}
            selectedKey={videoDuration}
          />
        </div>
        <h5 className="SectionTitle mt-4">
          {generateAIVideosText.backgroundMusicLabel}
        </h5>
        <YesNoOption
          onSelect={setEnableBackgroundMusic}
          value={enableBackgroundMusic}
          className="OptionsSection"
        />
        {enableBackgroundMusic && (
          <div className="BackgroundMusicOptions">
            <h5 className="SectionTitle mt-4">
              {generateAIVideosText.backgroundMusicMoodLabel}
            </h5>
            <Dropdown
              options={BACKGROUND_MUSIC_OPTIONS}
              selectedOption={
                backgroundAudioFile ? undefined : backgroundMusicType
              }
              setSelectedOption={onMusicTypeChange}
              className="BackgroundMusicDropdown"
              isMandatory
              placeholder={generateAIVideosText.selectMusicPlaceholder}
            />
            <h5 className="SectionTitle mt-4">
              {generateAIVideosText.orSelectFromLibrary}
            </h5>
            <LibraryFilesInput
              onBrowse={onBrowseAudio}
              files={backgroundAudioFile ? [backgroundAudioFile] : []}
              onRemoveFile={() => onRemoveAudioFile()}
              singleFile
            />
          </div>
        )}
      </div>
    );
  },
);

export default VideoDuratonStep;
